import { React, useEffect, useRef, useState } from 'react';
import Select from 'react-select'
import { connect, useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify';
import { Prompt } from "react-router-dom";
import { getSettings } from '../../../actions/account';
import { reportIssue } from '../../../actions/report'
import { verifyLength } from '../../../helper';
import BlackCross from '../../../assets/images/cross.png';
import Loading from '../../../components/Loading';
import { Input } from 'reactstrap'

function ReportProblem() {
    const [issueList, setIssueList] = useState([]);
    const [issueOptions, setIssueOptions] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [comments, setComments] = useState('');
    const [fileName, setFileName] = useState([]);
    const [underSize, setUnderSize] = useState(false);
    const [filesUnderSize, setFilesUnderSize] = useState([]);
    const [submitDisable, setSubmitDisable] = useState(false);
    const [cancelDisable, setCancelDisable] = useState(false);
    const [inputDisable, setInputDisable] = useState(false);

    const [errComments, setErrComments] = useState('');
    const [errFileUpload, setErrFileUpload] = useState('');

    const dispatch = useDispatch()
    const gameSettings = useSelector(state => state.account.data)
    const token = useSelector(state => state.auth.token)
    const reportMessage = useSelector(state => state.report.resMessage)
    const reportStatus = useSelector(state => state.report.resStatus)

    const previousProps = useRef({ reportMessage, reportStatus }).current

    useEffect(() => {
        setLoading(true)
        dispatch(getSettings)
        document.title = "RUMMY RANI | My Account"
    }, [])

    useEffect(() => {
        if (previousProps.reportMessage !== reportMessage) {
            if (reportMessage?.length) {
                setInputDisable(false)
                setUnderSize(false)
                toast(
                    <div>
                        <div>{reportMessage === "success." ? "Report submitted successfully." : reportMessage}</div>
                    </div>
                );
            }
        }
        return () => {
            previousProps.reportMessage = reportMessage
        }
    }, [reportMessage])

    useEffect(() => {
        if (previousProps.reportStatus !== reportStatus) {
            if (reportStatus === false) {
                setLoading(false)
                setSelectedOption('')
                setComments('')
                setFilesUnderSize([])
                setInputDisable(false)
                setUnderSize(false)
            }
            if (reportStatus === true) {
                setLoading(false)
                setSelectedOption('')
                setComments('')
                setFilesUnderSize([])
                setInputDisable(false)
                setUnderSize(false)
            }
        }
        return () => {
            previousProps.reportStatus = reportStatus
        }
    }, [reportStatus])

    useEffect(() => {
        if (gameSettings) {
            setLoading(false)
            setIssueList(gameSettings?.aReportDropDown)
        }
    }, [gameSettings])

    useEffect(() => {
        if (issueList?.length) {
            const options = issueList.map(option => ({ label: option, value: option }));
            setIssueOptions(options)
        }
    }, [issueList])

    function handleOptions(e) {
        setSelectedOption(e.value)
    }

    useEffect(() => {
        if (filesUnderSize?.length) {
            window.onbeforeunload = function () {
                return true;
            };
        }

        return () => {
            window.onbeforeunload = null;
        };
    }, [filesUnderSize]);

    function handleFile(e) {
        if (e.target.files?.length <= 4) {
            const fileArray = [...e.target.files]
            let resultArray = fileArray.sort((a, b) => a.size - b.size);

            const valid = resultArray.every(function (arr) { return arr.type.includes('image') || arr.type.includes('video') });
            if (valid) {
                if (resultArray.map(file => {
                    if (file.type.includes("video")) {
                        if (file?.size > 15728640) {
                            setErrFileUpload("Video size must be less than 15 MB")
                            setUnderSize(false)
                        } else {
                            setUnderSize(true)
                        }
                    }
                    if (file.type.includes("image")) {
                        if (file?.size > 4048576) {
                            setErrFileUpload("Image size must be less than 4 MB")
                            setUnderSize(false)
                        } else {
                            setUnderSize(true)
                        }
                    }
                }
                ))
                    setFileName(fileArray)
            } else {
                setUnderSize(false)
                setInputDisable(false)
                setErrFileUpload("Please select Image(s) or Video(s)")
            }

        }
        else {
            e.preventDefault();
            setErrFileUpload("Please select only 4 files")
        }
    }

    useEffect(() => {
        if (underSize === true) {
            setErrFileUpload('')
            setInputDisable(true)
            setFilesUnderSize(fileName)
        }
    }, [underSize])

    function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        const formdata = new FormData()
        formdata.append('sTitle', selectedOption)
        formdata.append('sDescription', comments)
        formdata.append('eCategory', selectedOption)
        // filesUnderSize?.length && formdata.append('aMedia', filesUnderSize)
        formdata.append('aMedia', fileName[0])
        dispatch(reportIssue(formdata, token))
    }

    function handleComments(e) {
        if (verifyLength(e.target.value, 1)) {
            setErrComments('')
        } else if (!verifyLength(e.target.value, 1)) {
            setErrComments('Please describe the issue you have been facing')
        }
        setComments(e.target.value)
    }

    useEffect(() => {
        if (selectedOption?.length && comments?.length && !errComments && !errFileUpload) {
            setSubmitDisable(true)
        } else {
            setSubmitDisable(false)
        }
    }, [selectedOption, comments, errFileUpload])

    useEffect(() => {
        if (selectedOption?.length || comments?.length || filesUnderSize?.length) {
            setCancelDisable(true)
        } else {
            setCancelDisable(false)
        }
    }, [selectedOption, comments, filesUnderSize])

    function handleCancel() {
        setSelectedOption('')
        setComments('')
        setFilesUnderSize([])
        setErrComments('')
        setErrFileUpload('')
        setUnderSize(false)
        setInputDisable(false)
    }

    function handleRemoveMedia() {
        setFilesUnderSize([])
        setErrFileUpload('')
        setUnderSize(false)
        setInputDisable(false)
    }

    function handleRemoveIndividualMedia(nameID) {
        const filteredFiles = filesUnderSize.filter(item => item.name !== nameID);
        setFilesUnderSize(filteredFiles)
        if (filteredFiles?.length === 0) {
            setInputDisable(false)
            setFilesUnderSize([])
            setUnderSize(false)
        }
    }

    const tempOptions = [
        { label: 'Disconnection', value: 'Disconnection' },
        { label: 'Score Not Updated Properly', value: 'Score Not Updated Properly' },
        { label: 'Winning Amount Not Credited', value: 'Winning Amount Not Credited' },
        { label: 'Others', value: 'Others' }
    ]

    return (
        <>
            <div className="report-probblem-sec cmn-banner-bg about-page-section ">
                <div className="change-psw-section reporting-box">
                    <h3 className="text-center account-title page-title">Report Problem</h3>
                    <div className='container'>
                        <div className="report-inner-box about-us-content">
                            <div className=" mx-auto">
                                <form>
                                    <div className="row align-items-baseline">
                                        <div className="col-xl-3 col-lg-5 text-right">
                                            <div>
                                                <label className="label">Select Issue :</label>
                                            </div>
                                        </div>
                                        <div className="col-xl-9 col-lg-7 ">
                                            <div className="d-flex form-group">
                                                <div className="cust-dropdown-wrap w-100">
                                                    <div className="cust-dropdown-box text-center w-100">
                                                        <div className='form1'>
                                                            <Select
                                                                options={tempOptions}
                                                                placeholder='Select an Issue'
                                                                className="select-custom1"
                                                                classNamePrefix="select-custom"
                                                                onChange={(e) => handleOptions(e)}

                                                                value={issueOptions?.length && issueOptions.filter(function (option) {
                                                                    return option.value === selectedOption;
                                                                })}
                                                            />

                                                            {/* <Input id="issue-select" name="select" type="select" >
                                                        <option>

                                                        </option>
                                                        <option>
                                                            Game disconnected automatically
                                                        </option>
                                                        <option>
                                                            Added money not reflacted in my account
                                                        </option>
                                                        <option>
                                                            Winning amount not added in total
                                                        </option>
                                                        <option>
                                                            Not able to join Practice games
                                                        </option>
                                                    </Input> */}
                                                            {/* <img src={DropDownArrowWhite} className="cust-down-aroow" alt="Down arrow" /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-5 text-right">
                                            <label className="label">Comments :</label>
                                        </div>
                                        <div className="col-xl-9 col-lg-7">
                                            <div className="form-group pass-field d-flex flex-column">
                                                <Input placeholder="Enter Comments" className='Report_Problem_Comments' value={comments} onChange={handleComments} maxLength="200" id="exampleText1" name="text" type="textarea" rows="7" />
                                                <div className="text-left">
                                                    <p>Max 200 Char</p>
                                                </div>
                                                <p className="error-text error-red">{errComments}</p>
                                            </div>

                                        </div>
                                        <div className="col-sm-12">
                                            <div className="row align-items-center">
                                                <div className="col-xl-3 col-lg-5 text-right">
                                                    <div>
                                                        <label className="label">Attachments :</label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-9 col-lg-7 d-flex attchmets-sec">
                                                    <div className={filesUnderSize?.length ? 'file-wrapper d-flex align-items-start' : "file-hidden "} >
                                                        {!!filesUnderSize?.length &&
                                                            filesUnderSize.map((file, i) =>
                                                                <div key={i} className="file-details">
                                                                    <p className="medium-text gray-text">{file?.name}</p>

                                                                    {/* <br /><br /> */}
                                                                </div>
                                                            )}
                                                        <button type="button" onClick={handleRemoveMedia} className={filesUnderSize?.length ? "p-0 border-0 bg-transparent close-btn" : 'd-none'}>
                                                            <img src={BlackCross} alt="removeMedia" />
                                                        </button>
                                                    </div>

                                                    <div className="d-flex flex-lg-wrap flex-xl-nowrap flex-xl-column flex-column">


                                                        {/* <div className="form-group pass-field browse-file-box d-flex w-100">
                                                <div className="problem-attach  w-100">
                                                    <input type="text" />
                                                </div>
                                            </div> */}

                                                        <div className="custom-file">
                                                            {/* <div className="yellow-btn browse-btn"><span> Choose1111 </span></div> */}

                                                            {/* <button type="submit" className="yellow-btn browse-btn"><span> Choose </span></button> */}
                                                            {/* <input type="file" disabled={inputDisable} accept="image/*,video/*" onChange={(e) => handleFile(e)} onClick={(e) => {
                                                    e.target.value = null
                                                }} /> */}
                                                            {/* {filesUnderSize?.length ?
                                                        filesUnderSize.map((file, i) =>
                                                            <div key={i} className="file-details">
                                                                <p className="medium-text gray-text">{file?.name}</p>

                                                                <br /><br />
                                                            </div>
                                                        )
                                                        : */}
                                                            <>
                                                                <div className='upload-btn-box d-flex '>
                                                                    <input type="file" className='inputFileReportProblem' accept="image/*,video/*" onChange={(e) => handleFile(e)} onClick={(e) => {
                                                                        e.target.value = null
                                                                    }} />
                                                                    <button type='submit' className="backgroundbtn"><span> Choose </span></button>
                                                                </div>
                                                            </>
                                                            {/* <button onClick={() => handleRemoveIndividualMedia(file?.name)} type="button" className="p-0 border-0 bg-transparent">
                                                                <img src={BlackCross} alt="removeMedia" />
                                                             </button>
                                                         <p className="medium-text gray-text">Drop your file(s) here or <span className="common-link fw-bold">Browse</span></p> */}
                                                            {/* } */}

                                                            {/* <input
                                                    type="file"
                                                    id="file-upload-box-problem"
                                                /> */}
                                                        </div>
                                                        <div className="text-xl-right text-lg-left"><p>Image upto 4MB / Video upto 15MB</p></div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-xl-3 col-lg-5 text-right'></div>
                                            <div className="col-xl-9 col-lg-7 d-flex justify-content-end sizing-error">
                                                <p className="error-text error-red">{errFileUpload}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="problem-btn-box d-flex justify-content-center align-items-center mx-auto">
                                        <button disabled={!submitDisable} type="button" onClick={handleSubmit} className="common-btn ">Submit</button>
                                        <button type="button" className="backgroundbRedBtn" onClick={handleCancel} disabled={!cancelDisable}>
                                            <span className="bg-layer"><span className="bg-layer-inner"></span></span>
                                            <span className="main-layer">Cancel</span>
                                        </button>

                                        {/* <button type="submit" className="yellow-btn browse-btn"><span> Submit </span>
                                    </button>
                                    <button type="button" className="common-outline-btn" data-toggle="" data-target="">
                                        <span className="bg-layer"><span className="bg-layer-inner"></span></span>
                                        <span className="main-layer">Cancel</span>
                                    </button> */}
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default connect()(ReportProblem);
